import React from 'react'
import MessagesComponent from '../../components/Profile/Messages'

function Messages () {
  return  <MessagesComponent/>
}
export default Messages